import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsTipoTabelaClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/tipo-tabela');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Tabela');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/tipo-tabela', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Tipo Tabela');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/tipo-tabela', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Tipo Tabela');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/tipo-tabela/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Tipo Tabela');
    }
  }

  async update(data) {
    try {
      const { data: response } = await this.api.put('/tipo-tabela', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Tipo Tabela');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/tipo-tabela/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Tipo Tabela');
    }
  }
}
